import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.8 1.067c-.955 0-1.733.777-1.733 1.733S1.845 4.533 2.8 4.533 4.534 3.756 4.534 2.8 3.756 1.067 2.8 1.067M2.8 6.267c-.955 0-1.733.777-1.733 1.733S1.845 9.733 2.8 9.733 4.534 8.956 4.534 8 3.756 6.267 2.8 6.267M2.8 11.467c-.955 0-1.733.777-1.733 1.733s.778 1.733 1.733 1.733 1.734-.777 1.734-1.733-.778-1.733-1.734-1.733M8 1.067c-.955 0-1.733.777-1.733 1.733S7.045 4.533 8 4.533 9.734 3.756 9.734 2.8 8.956 1.067 8 1.067M8 6.267c-.955 0-1.733.777-1.733 1.733S7.045 9.733 8 9.733 9.734 8.956 9.734 8 8.956 6.267 8 6.267M8 11.467c-.955 0-1.733.777-1.733 1.733S7.045 14.933 8 14.933s1.734-.777 1.734-1.733S8.956 11.467 8 11.467M13.2 4.533c.956 0 1.734-.777 1.734-1.733s-.778-1.733-1.734-1.733c-.955 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733M13.2 6.267c-.955 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733S14.934 8.956 14.934 8s-.778-1.733-1.734-1.733M13.2 11.467c-.955 0-1.733.777-1.733 1.733s.777 1.733 1.733 1.733 1.734-.777 1.734-1.733-.778-1.733-1.734-1.733"
    }, null, -1)
  ]))]))
}
export default { render: render }